export const getMenuItems = (
  reservaPeriodo: any[],
  reservaSemPeriodo: any[],
  periodoUsuarioId: number | null | undefined
) => {
  // Se não houver parâmetro na URL
  if (periodoUsuarioId == null) {
    return [{ key: "1", label: "Ver Hóspedes" }];
  }

  // Se houver parâmetro na URL e reservaPeriodo.length > 0
  if (periodoUsuarioId != null && reservaPeriodo.length > 0) {
    return [{ key: "1", label: "Ver Hóspedes" }];
  }

  // Caso contrário, exibe ambas as opções
  return [
    { key: "1", label: "Ver Hóspedes" },
    { key: "2", label: "Vincular Período a Reserva" },
  ];
};
